var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.875C3.75 12.5625 4.3125 13.125 5 13.125H10C10.6875 13.125 11.25 12.5625 11.25 11.875V5.625C11.25 4.9375 10.6875 4.375 10 4.375H5C4.3125 4.375 3.75 4.9375 3.75 5.625V11.875ZM11.25 2.5H9.6875L9.24375 2.05625C9.13125 1.94375 8.96875 1.875 8.80625 1.875H6.19375C6.03125 1.875 5.86875 1.94375 5.75625 2.05625L5.3125 2.5H3.75C3.40625 2.5 3.125 2.78125 3.125 3.125C3.125 3.46875 3.40625 3.75 3.75 3.75H11.25C11.5938 3.75 11.875 3.46875 11.875 3.125C11.875 2.78125 11.5938 2.5 11.25 2.5Z",
    fill: "#052C42",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRounded);
export default __webpack_public_path__ + "static/media/DeleteRounded.a24a644a5d3eff61d341771f65cb9aab.svg";
export { ForwardRef as ReactComponent };